import { performRequest } from "./utils/RequestUtils";
import { CUSTOM_ENDPOINT } from "./utils/EndPoint";

export const getCustomStories = async ({ plan_id }) => {
  return performRequest("get", `${CUSTOM_ENDPOINT}/stories?plan_id=${plan_id}`);
};

export const getCustomStoryOptions = async ({ story_id }) => {
  return performRequest("get", `${CUSTOM_ENDPOINT}/story/${story_id}`);
};

export const customUploadImage = async (formData) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/upload`, formData);
};

export const customCreateCharacter = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/character`, data);
};

export const getCharacterStatus = async ({ job_id }) => {
  return performRequest("get", `${CUSTOM_ENDPOINT}/character/${job_id}`);
};

export const createCustomStory = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/story`, data);
};

export const createCustomStoryImage = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/scene/images`, data);
};

export const regenerateCustomStoryImage = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/regenerate/scene`, data);
};

export const customCreateTitle = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/title`, data);
};

export const customCreateCoverPrompt = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/cover/prompt`, data);
};

export const customCreateCoverImage = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/create/cover/image`, data);
};

export const customSaveBook = async (data) => {
  return performRequest("post", `${CUSTOM_ENDPOINT}/save/book`, data);
};

export const getCustomStyle = async () => {
  return performRequest("get", `${CUSTOM_ENDPOINT}/styles`);
};

export const getCustomLoadingImage = async ({ user_id }) => {
  return performRequest("get", `${CUSTOM_ENDPOINT}/loading/${user_id}`);
};
